// @flow

import type { Keys } from '@zapier/common-utils/src/types';

const getKeys = (keys: ?Keys): string[] => {
  if (keys == null) {
    return [];
  }
  if (!Array.isArray(keys)) {
    return [keys];
  }
  return keys;
};

export default getKeys;
